/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetRegisterDto } from './GetRegisterDto';
import {
    GetRegisterDtoFromJSON,
    GetRegisterDtoFromJSONTyped,
    GetRegisterDtoToJSON,
} from './GetRegisterDto';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';
import type { GetRegisterNumberingDto } from './GetRegisterNumberingDto';
import {
    GetRegisterNumberingDtoFromJSON,
    GetRegisterNumberingDtoFromJSONTyped,
    GetRegisterNumberingDtoToJSON,
} from './GetRegisterNumberingDto';

/**
 * 
 * @export
 * @interface GetJudgmentNumberingDto
 */
export interface GetJudgmentNumberingDto {
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentNumberingDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetJudgmentNumberingDto
     */
    year?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetJudgmentNumberingDto
     */
    actualNumber?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetJudgmentNumberingDto
     */
    month?: number | null;
    /**
     * 
     * @type {GetRegisterDto}
     * @memberof GetJudgmentNumberingDto
     */
    register?: GetRegisterDto | null;
    /**
     * 
     * @type {GetRegisterNumberingDto}
     * @memberof GetJudgmentNumberingDto
     */
    registerNumbering?: GetRegisterNumberingDto | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetJudgmentNumberingDto
     */
    user?: GetUserDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetJudgmentNumberingDto
     */
    symbol?: string | null;
}

/**
 * Check if a given object implements the GetJudgmentNumberingDto interface.
 */
export function instanceOfGetJudgmentNumberingDto(value: object): value is GetJudgmentNumberingDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetJudgmentNumberingDtoFromJSON(json: any): GetJudgmentNumberingDto {
    return GetJudgmentNumberingDtoFromJSONTyped(json, false);
}

export function GetJudgmentNumberingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetJudgmentNumberingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'year': json['year'] == null ? undefined : json['year'],
        'actualNumber': json['actualNumber'] == null ? undefined : json['actualNumber'],
        'month': json['month'] == null ? undefined : json['month'],
        'register': json['register'] == null ? undefined : GetRegisterDtoFromJSON(json['register']),
        'registerNumbering': json['registerNumbering'] == null ? undefined : GetRegisterNumberingDtoFromJSON(json['registerNumbering']),
        'user': json['user'] == null ? undefined : GetUserDtoFromJSON(json['user']),
        'symbol': json['symbol'] == null ? undefined : json['symbol'],
    };
}

export function GetJudgmentNumberingDtoToJSON(value?: GetJudgmentNumberingDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'year': value['year'],
        'actualNumber': value['actualNumber'],
        'month': value['month'],
        'register': GetRegisterDtoToJSON(value['register']),
        'registerNumbering': GetRegisterNumberingDtoToJSON(value['registerNumbering']),
        'user': GetUserDtoToJSON(value['user']),
        'symbol': value['symbol'],
    };
}

